import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";

import { DEBOUNCE_DELAY_MS } from "../constants.js";

interface UseTeamMembersSearchParams {
  resetPagination: () => void;
}

export const useTeamMembersSearch = ({
  resetPagination,
}: UseTeamMembersSearchParams) => {
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        setSearchTerm(value.trim());
        resetPagination();
      }, DEBOUNCE_DELAY_MS),
    [resetPagination]
  );

  useEffect(
    () => () => {
      debouncedSearch.cancel();
    },
    [debouncedSearch]
  );

  const resetSearch = useCallback(() => {
    setSearchInput("");
    setSearchTerm("");
    resetPagination();
  }, [resetPagination]);

  return {
    debouncedSearch,
    resetSearch,
    searchInput,
    searchTerm,
    setSearchInput,
  };
};
